import { useEffect, useState } from "react";
import { AxiosError } from "axios";
import { BASE_URL, TypeDataSource } from "../helpers/constants";
import useApiRequest from "../helpers/api_request";
import { selectAccessToken } from "../features/auth/authSlice";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { showToastMessage } from "../features/generalSlice";
import { toast } from "react-toastify";

const useDataSources = () => {
  const [loadingDataSources, setLoadingDataSources] = useState(false);
  const accessToken = useAppSelector(selectAccessToken);
  const [dataSources, setDataSources] = useState<TypeDataSource[] | []>([]);
  const apiRequest = useApiRequest();
  const dispatch = useAppDispatch();

  const getDataSources = async () => {
    setLoadingDataSources(true);
    await apiRequest({
      method: 'get',
      url: BASE_URL + "/api/data-source",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        setLoadingDataSources(false);
        setDataSources(response.data);
      })
      .catch((error) => {
        const errorResponse = error as AxiosError;
        if (errorResponse.response) {
          const data = errorResponse.response.data as { message: string, status: string };
          dispatch(
            showToastMessage({
              message: data.message,
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        } else {
          dispatch(
            showToastMessage({
              message: "Something went wrong",
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        }
        setLoadingDataSources(false);
      });
  };

  return {
    loadingDataSources,
    dataSources,
    getDataSources,
  };
};

export default useDataSources;
